import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import { CHILDREN_DETAILS } from '../../Summaries/SummaryConstants';
import dictionarySelector from '../../Summaries/SummaryDictionarySelector';

const nextIteratorsSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
  dictionarySelector,
  (supportData, previousSupportData, dictionary) => {
    const hasChildren = get(supportData, `${BACKEND_KEY}.HasChildren`);
    if (hasChildren === get(previousSupportData, `${BACKEND_KEY}.HasChildren`)) {
      return [];
    }
    if (hasChildren === true) {
      return [CHILDREN_DETAILS].map(dependencies => dictionary[dependencies].iterator);
    }
    return [];
  },
);

export default nextIteratorsSelector;
